import {getMissingFeaturesAndClickThem} from "./lookNavigation/lookNavigationFunctions";

export const featureCanChangeShowerSize = (feature) => {
  if (!feature) {
    return false
  }
  return feature.partId === "shower_pan_combo" || feature.partId === "walk_in_tub" || feature.partId === "shower_body"
}

const neededFeatureGroupsToCheckOnShowerSizeChange = document.kvConfig.toolVersion === 5
  ? ["shower_pan_combo", "shower_interior_wall", "left_wall", "right_wall", "bathroom_floor", "shower_fixture"]
  : ["shower_wall", "split_wall", "left_wall_splitter", "bathroom_floor", "front_wall", "shower_fixture"];

/**
 * Checks needed features on ShowerSize change
 * @param clickedFeature {object}
 * @returns {promise}
 */
export const searchForSameNameWallsBeforeFeatureApply = async (clickedFeature) => {
  if (!clickedFeature.getParent) {
    return
  }
  const showerPanComboParent = clickedFeature.getParent();
  if (clickedFeature.metaData["ShowerSize"] && clickedFeature.metaData["ShowerSize"][0] && showerPanComboParent.activeFeature
    && showerPanComboParent.activeFeature.metaData["ShowerSize"]
    && (showerPanComboParent.activeFeature.metaData["ShowerSize"][0] !== clickedFeature.metaData["ShowerSize"][0])) {

    const showerParent = showerPanComboParent.getParent();
    const layout = showerParent.layout;

    let missingFeatures = [];
    const newSizeCondition = {
      propName: "ShowerSize",
      propValue: clickedFeature.metaData["ShowerSize"][0]
    };
    neededFeatureGroupsToCheckOnShowerSizeChange.forEach((partId) => {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup && featureGroup.activeFeature && !featureGroup.activeFeature.matchesMetaForCondition(newSizeCondition)) {
        const navigationItemName = featureGroup.activeFeature.getSplittedFeatureName();
        const newConditions = featureGroup.getArrayOfConditions().map(condition => {
          if (condition.propName === "ShowerSize") {
            return newSizeCondition
          }
          return condition
        });
        const featureFound = featureGroup.features.find(feature => {
          return (feature.getSplittedFeatureName() === navigationItemName) && feature.matchesMetaForArrayOfConditions(newConditions)
        });
        if (!featureFound &&
          !(featureGroup && featureGroup.alreadyRequestedFeatureNames && featureGroup.alreadyRequestedFeatureNames.includes(navigationItemName))) {
          missingFeatures.push({
            relatedItem: featureGroup,
            navigationItemName,
            setCurrentFeature: false
          })
        }
      }
    });
    if (missingFeatures.length) {
      await getMissingFeaturesAndClickThem(missingFeatures, true)
    }
  }

  return Promise.resolve();
}
